export default function Buttons(theme) {
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    whiteSpace: 'nowrap',
                    wordBreak: 'keep-all',
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: theme.shape.borderRadius,
                    fontFamily: theme.typography.button.fontFamily,
                    fontSize:theme.typography.button.fontSize,
                    fontWeight: theme.typography.button.fontWeight,
                    lineHeight: theme.typography.button.lineHeight,
                    transition: "all 0.3s ease",
                    boxShadow: `${theme.shadows[0]} !important`,
                    textTransform: 'none',
                    WebkitFontSmoothing: "antialiased",
                    '&.Mui-disabled': {
                        backgroundColor: `${theme.palette.grey[500]} !important`,
                        color: `${theme.palette.grey[700]} !important`,
                        border: `1px solid ${theme.palette.grey[500]}  !important`,
                        cursor: 'not-allowed',
                    },
                },
                contained: {
                    backgroundColor: theme.palette.button.primary,
                    color:theme.palette.grey[0],
                    border: `1px solid ${theme.palette.button.primary}`,
                    '&:hover': {
                        background: theme.palette.button.highlight,
                        boxShadow: 'none',
                    },
                    height: '42px',

                },
                outlined: {
                    backgroundColor: theme.palette.grey[0],
                    color: theme.palette.button.primary,
                    border: `1px solid ${theme.palette.button.primary}`,
                    '&:hover': {
                        backgroundColor: theme.palette.primary.lighter,
                        border: `1px solid ${theme.palette.button.primary}`,
                    },
                    height: '42px',
                },
                update: {
                    backgroundColor: 'transparent',
                    color: theme.palette.button.primary,
                    border: `1px solid ${theme.palette.grey[0]}`,
                    '&:hover': {
                        backgroundColor: 'transparent',
                        border: `1px solid ${theme.palette.grey[0]}`,
                    }
                },
                complete: {
                    backgroundColor:theme.palette.success.dark,
                    color: theme.palette.grey[0],
                    border: `1px solid ${theme.palette.success.dark}`,
                    '&:hover': {
                        backgroundColor: theme.palette.success.darker,
                        border: `1px solid ${theme.palette.success.darker}`,
                    }
                },
                request: {
                    backgroundColor:theme.palette.warning.dark,
                    color: theme.palette.grey[0],
                    border: `1px solid ${theme.palette.warning.dark}`,
                    '&:hover': {
                        backgroundColor: theme.palette.warning.highlight,
                        border: `1px solid ${theme.palette.warning.highlight}`,
                    }
                },
                danger:{
                    backgroundColor:theme.palette.error.dark,
                    color: theme.palette.grey[0],
                    border: `1px solid ${theme.palette.error.dark}`,
                    '&:hover': {
                        backgroundColor: theme.palette.error.darker,
                        border: `1px solid ${theme.palette.error.darker}`,
                    } 
                },
                text: {
                    color: theme.palette.button.primary,
                    '&:hover': {
                        backgroundColor: theme.palette.grey[0],
                    },
                    '&.Mui-disabled': {
                        backgroundColor: 'transparent !important',
                        border: 'none !important'
                    }
                }
            }
        }
    };
}